module.exports = __webpack_public_path__ + "img/userplaceholder.df6b688e.svg";